// extracted by mini-css-extract-plugin
export var backupIcon = "_ok-1";
export var image = "_ok-0";